module.exports = __webpack_public_path__ + "img/banner.d366950f.png";